export function getHeaderClass(shopDomain: string): string {
    // Custom request by this store to remove the widget's .header class
    return shopDomain === "e62ffe.myshopify.com" ? "stages-ora-header" : "header";
}
